import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, toggle }) => {
  return (
    <div className="bg-white rounded-xl border-2 border-gray-100 hover:border-[#F9A825] transition-all duration-300 shadow-sm hover:shadow-md mb-4">
      <button
        onClick={toggle}
        className="w-full px-6 py-5 flex items-start justify-between text-left focus:outline-none group"
      >
        <div className="flex items-start space-x-4 flex-1">
          <div className="w-8 h-8 bg-[#F9A825] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-white font-bold text-sm">?</span>
          </div>
          <h3 className="text-lg font-semibold text-[#004C97] group-hover:text-[#F9A825] transition-colors pr-8">
            {question}
          </h3>
        </div>
        <ChevronDown 
          className={`w-6 h-6 text-[#F9A825] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`}
        />
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="px-6 pb-6 pl-[72px]">
          <p className="text-gray-700 leading-relaxed">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
};

const FAQAccordion = ({ faqs, defaultOpen = null }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-0">
      {faqs.map((faq, index) => (
        <FAQItem
          key={index}
          question={faq.question}
          answer={faq.answer}
          isOpen={openIndex === index}
          toggle={() => toggleItem(index)}
        />
      ))}
    </div>
  );
};

export default FAQAccordion;
